import { render, staticRenderFns } from "./ElaryWarningBox.vue?vue&type=template&id=eccdb062&scoped=true&"
import script from "./ElaryWarningBox.vue?vue&type=script&lang=js&"
export * from "./ElaryWarningBox.vue?vue&type=script&lang=js&"
import style0 from "./ElaryWarningBox.vue?vue&type=style&index=0&id=eccdb062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eccdb062",
  null
  
)

export default component.exports